/* AUTH */
export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
/* DASHBOARD */
export const DASHBOARD_LOAD_LOCATION = 'DASHBOARD_LOAD_LOCATION'
export const DASHBOARD_TOGGLE_PAUSED = 'DASHBOARD_TOGGLE_PAUSED'
export const DASHBOARD_FILTER_ORDERS = 'DASHBOARD_FILTER_ORDERS'
/* CATALOG */
export const CATALOG_UPDATE_ITEM = 'CATALOG_UPDATE_ITEM'
export const CATALOG_GET_ITEMS = 'CATALOG_GET_ITEMS'
export const CATALOG_ERROR = 'CATALOG_ERROR'
/* NOTIFICATION */
export const NOTIFICATION_UPDATE_SUCCESS = 'NOTIFICATION_UPDATE_SUCCESS'
export const NOTIFICATION_UPDATE_ERROR = 'NOTIFICATION_UPDATE_ERROR'

export const DASHBOARD_UPDATE_ORDER = 'DASHBOARD_UPDATE_ORDER'